import React from "react";

import { Tooltip } from "@material-ui/core";
import AcceptedIcon from "@material-ui/icons/CheckCircleOutline";
import AcceptedStoredIcon from "@material-ui/icons/OfflinePinOutlined";
import ErrorIcon from "@material-ui/icons/Error";
import InTransitIcon from "@material-ui/icons/PauseCircleOutline";
import ShippeedIcon from "@material-ui/icons/RemoveCircleOutline";
import WarningIcon from "@material-ui/icons/Warning";
import { green, orange } from "@material-ui/core/colors";

import { InventoryStatus } from "../../../utils/constants";

export const InventoryStatusIcon = ({
  inventory,
  placement = "left",
  classes,
  ...props
}) => {
  if (!inventory) return null;

  return inventory.status === InventoryStatus.IN_TRANSIT ? (
    <Tooltip title="In Transit" placement={placement} arrow>
      <InTransitIcon color="inherit" className={classes} />
    </Tooltip>
  ) : inventory.verificationRequired === "true" ? (
    <Tooltip title="Verification Required" placement={placement} arrow>
      <WarningIcon className={classes} style={{ color: orange[600] }} />
    </Tooltip>
  ) : inventory.verificationRequired === "resolved" ? (
    <Tooltip title="Verified & Accepted" placement={placement} arrow>
      <ErrorIcon className={classes} style={{ color: green[600] }} />
    </Tooltip>
  ) : inventory.status === InventoryStatus.ARRIVED ? (
    <Tooltip title="Arrived" placement={placement} arrow>
      <InTransitIcon className={classes} style={{ color: green[600] }} />
    </Tooltip>
  ) : inventory.status === InventoryStatus.UNLOADED ? (
    <Tooltip title="Accepted & Unloaded" placement={placement} arrow>
      <AcceptedIcon className={classes} style={{ color: green[600] }} />
    </Tooltip>
  ) : inventory.status === InventoryStatus.STORED ||
    inventory.status === InventoryStatus.AGGREGATED ? (
    <Tooltip title="Accepted & Stored" placement={placement} arrow>
      <AcceptedStoredIcon className={classes} style={{ color: green[600] }} />
    </Tooltip>
  ) : inventory.status === InventoryStatus.SHIPPED ? (
    <Tooltip title="Depleted" placement={placement} arrow>
      <ShippeedIcon className={classes} style={{ color: green[600] }} />
    </Tooltip>
  ) : null;
};
